import {useDispatch} from "react-redux";
import {useEffect} from "react";
import {getProfile} from "../../store/reducers/profile.reducer";
import {useProfile} from "./useProfile";
import { useKeycloak } from "@react-keycloak/web";

export const useGetProfile = () => {
	const { keycloak } = useKeycloak();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getProfile(keycloak.token));
	}, [dispatch]);

	const profile = useProfile();

	return profile;
}